export default "__VITE_ASSET__A8kN73FP__"